import { gql } from '@apollo/client';

export const SEARCH_DOMAINS = gql`
  query SearchDomains($input: DomainSearchInput!) {
    searchDomains(input: $input) {
      domain
      available
      price
      currency
      premium
    }
  }
`;

export const MY_DOMAINS = gql`
  query MyDomains {
    myDomains {
      id
      domainName
      status
      expiryDate
      autoRenew
      nameservers {
        hostname
      }
    }
  }
`;
